import { useState } from 'react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { updateUser } from '../api/users';
import { queryKeys } from '../lib/react-query';

const useUpdateUser = () => {
  const [errorMessage, setErrorMessage] = useState<string>('');
  const [message, setMessage] = useState<string>('');
  const queryClient = useQueryClient();

  const updateMutation = useMutation({
    mutationFn: (userData: { [key: string]: any }) => updateUser(userData),
    onSuccess: () => {
      setErrorMessage('');
      setMessage('Dane użytkownika zostały zaktualizowane');
      queryClient.invalidateQueries({ queryKey: queryKeys.users.all });
    },
    onError: error => {
      setMessage('');

      if (error instanceof AxiosError) {
        const status = error.response?.status;

        if (status === 400) {
          const errors = error.response?.data?.errors;

          if (errors?.username && errors?.email) {
            setErrorMessage(
              'Podana nazwa użytkownika oraz adres email został już wykorzystany'
            );
            return;
          }

          if (errors?.username) {
            setErrorMessage('Podana nazwa użytkownika została już wykorzystana');
            return;
          }

          if (errors?.email) {
            setErrorMessage('Podany adres email został już wykorzystany');
            return;
          }
        }

        if (status === 500) {
          setErrorMessage(
            'Wystąpił błąd serwera. Skontaktuj się z administratorem.'
          );
          return;
        }
      }

      setErrorMessage('Wystąpił błąd podczas aktualizacji użytkownika');
    },
  });

  const update = async (userData: { [key: string]: any }) => {
    setErrorMessage('');
    setMessage('');

    try {
      await updateMutation.mutateAsync(userData);
      return true;
    } catch {
      return false;
    }
  };

  return {
    update,
    errorMessage,
    message,
    isPending: updateMutation.isPending,
  };
};

export default useUpdateUser;
